"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var Simplex = _interopRequireWildcard(require("@/libs/Simplex"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  components: {
    UserAvatar: _UserAvatar.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['network', 'buffer', 'user', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      whoisRequested: false,
      whoisLoading: false,
      inviteChan: '',
      simplexAddressDraft: Simplex.getSimplexAddress(),
      simplexAddress: '',
      simplexMessage: '',
      addressCopied: false,
      showSimplexInfo: false,
      showOwnSimplex: false,
      showOtherSimplex: false,
      showRemoteSimplex: false,
      showCommunityInviteInfo: false,
      pluginUiButtonElements: _GlobalApi.default.singleton().userboxButtonPlugins,
      pluginUiInfoElements: _GlobalApi.default.singleton().userboxInfoPlugins,
      pluginUiWhoisElements: _GlobalApi.default.singleton().userboxWhoisPlugins
    };
  },
  computed: {
    // Channel modes differ on some IRCds so get them from the network options
    availableChannelModes: function availableChannelModes() {
      var availableModes = [];
      var prefixes = this.network.ircClient.network.options.PREFIX;
      var knownPrefix = {
        q: 'Owner',
        a: 'Admin',
        o: 'Operator',
        h: 'Half-Operator',
        v: 'Voice'
      };
      prefixes.forEach(function (prefix) {
        var mode = prefix.mode;
        if (knownPrefix[mode]) {
          availableModes.push({
            mode: mode,
            description: knownPrefix[mode]
          });
        }
      });
      return availableModes;
    },
    extraFilterEnabled: function extraFilterEnabled() {
      var _this$buffer$users$th, _this$network$nick, _this$buffer$users$th2, _this$buffer$users$th3, _this$network$nick2;
      return !!((_this$buffer$users$th = this.buffer.users[(_this$network$nick = this.network.nick) === null || _this$network$nick === void 0 ? void 0 : _this$network$nick.toUpperCase()]) !== null && _this$buffer$users$th !== void 0 && _this$buffer$users$th.is_premium) || !!((_this$buffer$users$th2 = this.buffer.users[(_this$network$nick2 = this.network.nick) === null || _this$network$nick2 === void 0 ? void 0 : _this$network$nick2.toUpperCase()]) !== null && _this$buffer$users$th2 !== void 0 && (_this$buffer$users$th3 = _this$buffer$users$th2.realname) !== null && _this$buffer$users$th3 !== void 0 && _this$buffer$users$th3.match(/^[MFN]\d{2}[A-Z]{2}_/));
    },
    getGender: function getGender() {
      var parsed = this.parseUserRealname(this.user.realname);
      if (parsed) {
        switch (parsed.gender) {
          case 'M':
            return 'Uomo';
          case 'F':
            return 'Donna';
          case 'N':
            return 'Non binario';
          default:
            return null;
        }
      }
      return null;
    },
    genderCode: function genderCode() {
      var parsed = this.parseUserRealname(this.user.realname);
      return parsed ? parsed.gender : null;
    },
    getAge: function getAge() {
      var parsed = this.parseUserRealname(this.user.realname);
      if (parsed) {
        return parsed.age ? parsed.age : null;
      }
      return null;
    },
    getProvince: function getProvince() {
      var parsed = this.parseUserRealname(this.user.realname);
      if (parsed) {
        return parsed.city ? parsed.city : null;
      }
      return null;
    },
    areWeAnOp: function areWeAnOp() {
      if (!this.buffer) {
        return false;
      }
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    realname: function realname() {
      var _context;
      return (0, _trim.default)(_context = this.user.realname || '').call(_context);
    },
    formattedRealname: function formattedRealname() {
      var blocks = (0, _MessageParser.default)(this.realname, {
        extras: false
      });
      var content = (0, _Html.default)(blocks, false);
      return content;
    },
    isUserOnBuffer: function isUserOnBuffer() {
      if (!this.buffer) {
        return false;
      }
      if (!this.user.buffers[this.buffer.id]) {
        // Probably switched buffer while the userbox was open
        return false;
      }
      return true;
    },
    userMode: {
      get: function get() {
        if (!this.buffer) {
          return '';
        }
        var userBufferInfo = this.user.buffers[this.buffer.id];
        if (!userBufferInfo) {
          // Probably switched buffer while the userbox was open
          return '';
        }
        var modes = userBufferInfo.modes;
        return modes.length > 0 ? modes[0] : '';
      },
      // Switch the current user mode for the new one
      set: function set(newVal) {
        var _context2;
        var client = this.network.ircClient;
        var oldVal = this.userMode;
        var changes = [];
        var targets = [];
        if (oldVal) {
          changes.push('-' + oldVal);
          targets.push(this.user.nick);
        }
        if (newVal) {
          changes.push('+' + newVal);
          targets.push(this.user.nick);
        }
        var params = (0, _concat.default)(_context2 = ['MODE', this.buffer.name, changes.join('')]).call(_context2, targets);
        client.raw(params);
      }
    },
    userChannels: function userChannels() {
      var _context3, _context4;
      var channels = (0, _sort.default)(_context3 = (0, _trim.default)(_context4 = this.user.whois.channels).call(_context4).split(' ')).call(_context3, Misc.strCompare);
      for (var i = 0; i < channels.length; i++) {
        channels[i] = TextFormatting.linkifyChannels(channels[i]);
      }
      return channels.join(' ');
    },
    isSelf: function isSelf() {
      return this.user === this.network.currentUser();
    },
    simplexLinks: function simplexLinks() {
      return Simplex.SIMPLEX_LINKS;
    },
    canRequestSimplex: function canRequestSimplex() {
      return Simplex.isSimplexAddress(Simplex.getSimplexAddress()) || !!(this.network.currentUser() && this.network.currentUser().hasSimplex);
    },
    invitableBuffers: function invitableBuffers() {
      var _this = this;
      var buffers = [];
      this.network.buffers.forEach(function (buffer) {
        if (buffer.isChannel() && buffer.isUserAnOp(_this.network.nick) && !buffer.hasNick(_this.user.nick)) {
          buffers.push(buffer.name);
        }
      });
      return buffers;
    }
  },
  watch: {
    user: function user() {
      // Reset the whois view since the user is now different
      this.whoisRequested = false;
      this.whoisLoading = false;
      this.showOtherSimplex = false;
      this.showRemoteSimplex = false;
      this.showCommunityInviteInfo = false;
      this.showSimplexInfo = false;
      this.simplexMessage = '';
      this.addressCopied = false;
      this.loadSimplexProfile();
    }
  },
  created: function created() {
    var _this2 = this;
    this.listen(this.$state, 'simplex.address', function (payload) {
      if (payload.networkid !== _this2.network.id || payload.nick.toLowerCase() !== _this2.user.nick.toLowerCase()) {
        return;
      }
      Simplex.setRemoteSimplexAddress(payload.networkid, payload.nick, payload.address);
      _this2.simplexAddress = payload.address;
      _this2.showRemoteSimplex = true;
      _this2.simplexMessage = 'Contatto SimpleX ricevuto.';
    });
    this.listen(this.$state, 'metadata.simplex.saved', function (payload) {
      if (payload && payload.message) {
        _this2.simplexMessage = payload.message;
      }
    });
  },
  mounted: function mounted() {
    this.loadSimplexProfile();
  },
  methods: {
    loadSimplexProfile: function loadSimplexProfile() {
      if (this.isSelf) {
        this.simplexAddressDraft = Simplex.getSimplexAddress();
        this.simplexAddress = '';
        return;
      }
      this.simplexAddress = Simplex.getRemoteSimplexAddress(this.network.id, this.user.nick);
      this.showRemoteSimplex = !!this.simplexAddress;
    },
    openOwnSimplexProfile: function openOwnSimplexProfile() {
      this.$state.$emit('userbox.show', this.network.currentUser());
    },
    requestSimplexAddress: function requestSimplexAddress() {
      if (!this.canRequestSimplex) {
        this.simplexMessage = 'Imposta prima un contatto SimpleX valido.';
        return;
      }
      this.simplexMessage = 'Invio richiesta…';
      this.$state.$emit('metadata.simplex.request', {
        nick: this.user.nick
      });
    },
    saveOwnSimplexAddress: function saveOwnSimplexAddress() {
      try {
        this.simplexAddress = Simplex.saveSimplexAddress(this.simplexAddressDraft);
        this.simplexAddressDraft = this.simplexAddress;
        this.simplexMessage = this.simplexAddress ? 'Contatto SimpleX salvato.' : 'Contatto SimpleX rimosso.';
        this.$state.$emit('metadata.simplex.save', {
          address: this.simplexAddress
        });
      } catch (err) {
        this.simplexMessage = err.message;
      }
    },
    copyAddress: function copyAddress() {
      var _this3 = this;
      Simplex.copySimplexAddress(this.simplexAddress).then(function () {
        _this3.addressCopied = true;
        _this3.simplexMessage = 'Indirizzo copiato.';
        window.setTimeout(function () {
          _this3.addressCopied = false;
        }, 2000);
      }).catch(function () {
        _this3.addressCopied = false;
        _this3.simplexMessage = 'Non è stato possibile copiare l’indirizzo.';
      });
    },
    openAddress: function openAddress() {
      window.open(this.simplexAddress, '_blank', 'noopener');
    },
    parseUserRealname: function parseUserRealname(realname) {
      if (!realname) {
        return null;
      }
      // Regex: (Gender)(Age)(City)_any
      // Gender: M, F, U
      // Age: 2 digits or UU
      // City: 2 letters or UU (e.g. MI, FR, UU)
      var match = (typeof realname === 'string' ? realname : '').match(/^([MFNU])(\d{2}|UU)([A-Z]{2}|UU)_/);
      if (match) {
        return {
          gender: match[1] === 'U' ? null : match[1],
          // Will be 'M', 'F', or 'U'
          age: match[2] === 'UU' ? null : parseInt(match[2], 10),
          // null if 'UU', otherwise number
          city: match[3] === 'UU' ? null : match[3] // null if 'UU', otherwise city code
        };
      }

      return null; // Realname doesn't match the expected format
    },
    isContributor: function isContributor(network, nick) {
      var userState = this.$state.getUser(network, nick);
      return userState.is_contributor;
    },
    isPremiumAnnounced: function isPremiumAnnounced(network, nick) {
      var userState = this.$state.getUser(network, nick);
      return !!(userState && userState.is_premium && userState.wants_announce);
    },
    isBot: function isBot(network, nick) {
      var userState = this.$state.getUser(network, nick);
      return userState.is_bot;
    },
    hasAccount: function hasAccount(network, nick) {
      var userState = this.$state.getUser(network, nick);
      return userState === null || userState === void 0 ? void 0 : userState.account;
    },
    invite: function invite(event, nick) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this4.$state.getActiveNetwork().ircClient.say(nick, 'Registrati in 5 secondi e con solo un indirizzo e-mail su https://dashboard.chatt-gratis.net/register per usare tutte le funzionalità disponibili');
              _this4.addInfoMessageToBuffer('Invito inviato con successo.');
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee);
      }))();
    },
    addInfoMessageToBuffer: function addInfoMessageToBuffer(message) {
      var buffer = this.$state.getActiveBuffer();
      var mynick = this.$state.getActiveNetwork().nick;
      this.$state.addMessage(buffer, {
        message: message,
        bodyTemplate: '',
        nick: 'INFO',
        ident: 'INFO',
        hostname: 'INFO',
        target: mynick
      });
    },
    awaitMessage: function awaitMessage(ircClient, matcher) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          timeout: undefined
        },
        timeout = _ref.timeout;
      var connection = ircClient.connection;
      return new _promise.default(function (resolve, reject) {
        var timeoutHandle;
        if (timeout) {
          timeoutHandle = setTimeout(function () {
            connection.removeListener('message', callback);
            reject(new Error('Timeout expired'));
          }, timeout);
        }
        var callback = function callback(message) {
          try {
            if (matcher(message)) {
              connection.removeListener('message', callback);
              if (timeoutHandle) {
                clearTimeout(timeoutHandle);
              }
              resolve(message);
            }
          } catch (err) {
            connection.removeListener('message', callback);
            if (timeoutHandle) {
              clearTimeout(timeoutHandle);
            }
            reject(err);
          }
        };
        connection.on('message', callback);
      });
    },
    setAvatar: function setAvatar() {
      this.uploadImage();
    },
    uploadImage: function uploadImage(event) {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var ERR_UNKNOWNCOMMAND, ErrExtJwtUnsupported, respPromise, resp, _resp$params, token;
        return _regenerator.default.wrap(function _callee2$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              ERR_UNKNOWNCOMMAND = 421;
              ErrExtJwtUnsupported = new Error('EXTJWT unsupported on this server/gateway'); // send a raw message to the server
              respPromise = _this5.awaitMessage(_this5.network.ircClient, function (message) {
                if (message.command === String(ERR_UNKNOWNCOMMAND) && message.params[1].toUpperCase() === 'EXTJWT') {
                  throw ErrExtJwtUnsupported;
                }
                return message.command.toUpperCase() === 'EXTJWT' && message.params[0] === '*' && message.params[1] === '*';
              }, {
                timeout: 10 * 60
              });
              _this5.network.ircClient.raw('EXTJWT * myway');
              _context6.prev = 4;
              _context6.next = 7;
              return respPromise;
            case 7:
              resp = _context6.sent;
              _resp$params = (0, _slicedToArray2.default)(resp.params, 3), token = _resp$params[2]; // Check if the token is valid
              fetch("https://jwt.eggload.com/verify/?t=".concat(token)).then(function (res) {
                return res.json();
              }).then(function (data) {
                if (data === 'invalid or expired token') {
                  // console.log('invalid or expired token');

                  _this5.addInfoMessageToBuffer(_this5.$t('userbox_avatar_token_expired'));
                } else if (data.account) {
                  _this5.addInfoMessageToBuffer(_this5.$t('userbox_avatar_browser_tab_opened'));
                  // Open a new browser tab with the specified url
                  var popup = window.open("https://avatar.eggload.com/?jwt=".concat(token), '_blank');

                  // Check if popup was blocked
                  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
                    _this5.addInfoMessageToBuffer('Il popup è stato bloccato dal browser. Consenti temporaneamente i popup e riprova.');
                  }
                } else {
                  _this5.addInfoMessageToBuffer(_this5.$t('userbox_avatar_nickname_not_registered'));
                }
              });
              _context6.next = 16;
              break;
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](4);
              if (_context6.t0 === ErrExtJwtUnsupported) {
                // console.debug('Network does not support EXTJWT');
              }
              throw _context6.t0;
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee2, null, [[4, 12]]);
      }))();
    },
    isSupported: function isSupported(fileType) {
      if (fileType && fileType.match(/image\/.*/)) {
        return true;
      }
      return false;
    },
    openQuery: function openQuery() {
      this.sidebarState.showNicklist();
      var buffer = this.$state.addBuffer(this.network.id, this.user.nick);
      this.$state.setActiveBuffer(this.network.id, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('userbox.hide');
      }
    },
    onChannelsClick: function onChannelsClick(event) {
      var channelName = event.target.getAttribute('data-channel-name');
      if (channelName) {
        var network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
      }
    },
    updateWhoisData: function updateWhoisData() {
      var _this6 = this;
      this.whoisRequested = true;
      this.whoisLoading = true;
      this.network.ircClient.whois(this.user.nick, function () {
        _this6.whoisLoading = false;
      });
    },
    inviteUser: function inviteUser() {
      if (!this.inviteChan) {
        return;
      }
      this.network.ircClient.invite(this.inviteChan, this.user.nick);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserBox"]
window._kiwi_exports.components.UserBox = exports.default ? exports.default : exports;
